/** @format */
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import moment from 'moment/moment';
import { LocaleService } from 'sis-common';
import { PlanLoaderService } from '../common/service/plan-loader.service';
import { FirstLevelModuleService } from './service/first-level-module.service';
import { ModuleDescendantService } from './service/module-descendant.service';
import { SelectedPlanService } from './service/selected-plan.service';
import { SelectedValidatablePlanService } from './service/selected-validatable-plan.service';
import { TimingActionService } from './service/timing-action.service';
import { UntimedCourseUnitService } from './service/untimed-course-unit.service';
import { CurrentAndUpcomingStudyTermsService } from './timeline/current-and-upcoming-study-terms.service';
import { ParsedPlannedPeriodService } from './timeline/parsed-planned-period.service';
import { SelectedPlanStudyRightService } from './timeline/selected-plan-study-right.service';
import { StudyPeriodDataService } from './timeline/study-period-data.service';
import { TimelineStartDateService } from './timeline/timeline-start-date.service';
import { TimelineStudyPeriodsService } from './timeline/timeline-study-periods.service';
import { TimelineStudyYearsService } from './timeline/timeline-study-years.service';
import { TimelineTrimService } from './timeline/timeline-trim.service';

@Component({
    selector: 'app-timing',
    standalone: false,
    templateUrl: './timing.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        SelectedPlanService,
        SelectedPlanStudyRightService,
        SelectedValidatablePlanService,
        StudyPeriodDataService,
        TimelineStudyYearsService,
        TimelineStudyPeriodsService,
        TimingActionService,
        UntimedCourseUnitService,
        FirstLevelModuleService,
        ModuleDescendantService,
        ParsedPlannedPeriodService,
        TimelineStartDateService,
        TimelineTrimService,
        CurrentAndUpcomingStudyTermsService,
    ],
})
export class TimingComponent {
    protected readonly plans$ = inject(PlanLoaderService).allPlans$;

    protected readonly showSurvey: boolean = moment().isBetween(moment('2026-01-15T09:00:00'), moment('2026-02-15T23:59:59'));
    protected surveyUrl: string;

    constructor() {
        this.surveyUrl = this.getSurveyUrl();
    }

    getSurveyUrl(): string {
        const lang = inject(LocaleService).getCurrentLanguage();
        switch (lang) {
            case 'sv':
                return 'https://www.funilab.fi/activity/public/6/228?lang=sv';
            case 'en':
                return 'https://www.funilab.fi/activity/public/6/228?lang=en';
            case 'fi':
            default:
                return 'https://www.funilab.fi/activity/public/6/228?lang=fi';
        }
    }
}
